import { render, staticRenderFns } from "./Gsys.vue?vue&type=template&id=8980a1a0&"
import script from "./Gsys.vue?vue&type=script&lang=js&"
export * from "./Gsys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports